import { render } from "./ClanMetaDaSemana.vue?vue&type=template&id=1bf919b8&scoped=true"
import script from "./ClanMetaDaSemana.vue?vue&type=script&lang=js"
export * from "./ClanMetaDaSemana.vue?vue&type=script&lang=js"

import "./ClanMetaDaSemana.vue?vue&type=style&index=0&id=1bf919b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf919b8"]])

export default __exports__